module.exports = __webpack_public_path__ + "static/media/twitch.bf2d547a.svg";